import { Box } from "@chakra-ui/react"
import type { SkiFeatureDetail } from "../../../hooks/useResortFeatures"

type FeatureJsonTabProps = {
  data: SkiFeatureDetail
}

export default function FeatureJsonTab({ data }: FeatureJsonTabProps) {
  return (
    <Box
      as="pre"
      bg="gray.900"
      p="3"
      borderRadius="md"
      borderWidth="1px"
      borderColor="gray.700"
      overflowX="auto"
      fontSize="sm"
    >
      {data.source ? JSON.stringify(data.source, null, 2) : "No source data available"}
    </Box>
  )
}
